export const calendarDays=['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
export const calendarMonths=[
  "January", "February", "March", "April",
  "May", "June", "July", "August",
  "September", "October", "November", "December"
];